import { get } from '../../../common/utils/objectUtils';
import {
    ClubIntegrationPixelState,
    ClubIntegrationPixelActionTypes,
    FETCH_CLUB_INTEGRATION_PIXEL,
    FETCH_CLUB_INTEGRATION_PIXEL_SUCCESS,
    FETCH_CLUB_INTEGRATION_PIXEL_FAILED,
} from './types';

const LoggedInReducer = (
    state: ClubIntegrationPixelState = {
        isFetching: false,
        didInvalidate: false,
        url: '',
        error: null,
    },
    action: ClubIntegrationPixelActionTypes
): ClubIntegrationPixelState => {
    switch (action.type) {
        case FETCH_CLUB_INTEGRATION_PIXEL: {
            return {
                ...state,
                isFetching: true,
            };
        }
        case FETCH_CLUB_INTEGRATION_PIXEL_SUCCESS: {
            return {
                ...state,
                isFetching: false,
                url: get(action.payload, 'data.authImageUrl', ''),
                didInvalidate: false,
            };
        }
        case FETCH_CLUB_INTEGRATION_PIXEL_FAILED: {
            return {
                ...state,
                isFetching: false,
                didInvalidate: true,
                error: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default LoggedInReducer;
